import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const NotificationIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path stroke="currentColor" d="M14.5 19a2.5 2.5 0 0 1-5 0" />
            <path stroke="currentColor" strokeLinecap="round" d="M3.5 17.5h17" />
            <mask id="notification-icon_svg__a" fill="#fff">
                <path fillRule="evenodd" d="M19 10a7 7 0 1 0-14 0c0 4-1 8-1 8h16s-1-4-1-8Z" clipRule="evenodd" />
            </mask>
            <path
                fill="currentColor"
                d="m4 18-.97-.242L2.72 19H4v-1Zm16 0v1h1.28l-.31-1.242L20 18ZM12 4a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8v2Zm-6 6a6 6 0 0 1 6-6V2a8 8 0 0 0-8 8h2Zm-2 8 .97.242v-.001l.001-.003a1.686 1.686 0 0 0 .012-.049l.034-.142c.028-.122.069-.3.117-.525.096-.45.224-1.09.352-1.858C5.741 14.135 6 12.076 6 10H4c0 1.924-.241 3.865-.486 5.336a39.583 39.583 0 0 1-.445 2.257l-.03.126-.007.03-.002.007v.002L4 18Zm16-1H4v2h16v-2Zm-2-7c0 2.076.259 4.135.514 5.664a41.544 41.544 0 0 0 .47 2.383 20.133 20.133 0 0 0 .042.18l.003.01v.005L20 18l.97-.242v-.002l-.002-.006a24.004 24.004 0 0 1-.037-.157 39.559 39.559 0 0 1-.445-2.258C20.241 13.866 20 11.926 20 10h-2Z"
                mask="url(#notification-icon_svg__a)"
            />
        </svg>
    </IconWrapper>
)
